<template>
  <v-expansion-panels
    class="main-container"
    v-model="productData.model"
  >
    <v-expansion-panel>
      <v-expansion-panel-header hide-actions>
        <v-row class="pb-3">
          <!-- order product and delete product button -->
          <v-row class="order-product-container">
            <div
              class="number-product"
              @click.stop=""
            >
              {{ indexProduct + 1 }}
            </div>
            <div class="position-delete-product">
              <v-btn
                v-if="!isProductOnlyOne && editStatus"
                @click.stop="removeProduct(indexProduct)"
                icon
              >
                <svg
                  width="34"
                  height="33"
                  viewBox="0 0 34 33"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M17 31C25.2843 31 32 24.5081 32 16.5C32 8.49187 25.2843 2 17 2C8.71573 2 2 8.49187 2 16.5C2 24.5081 8.71573 31 17 31Z"
                    stroke="#E11717"
                    stroke-width="3"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M11.375 11.0625L22.625 21.9375"
                    stroke="#E11717"
                    stroke-width="3"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M22.625 11.0625L11.375 21.9375"
                    stroke="#E11717"
                    stroke-width="3"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </v-btn>
            </div>
          </v-row>

          <!-- field input zone -->
          <v-row
            no-gutters
            align="center"
            class="header-product-section"
          >
            <v-col
              cols="12"
              sm="6"
            >
              <v-row
                no-gutters
                class="pr-sm-2 pr-md-6"
                align="center"
              >
                <v-col
                  cols="12"
                  md="12"
                  lg="4"
                  align-self="center"
                >
                  รายการสินค้า
                </v-col>
                <v-col
                  cols="12"
                  md="12"
                  lg="7"
                >
                  <v-tooltip
                    top
                    :disabled="
                      !(
                        productData.item?.material_name ||
                        productData?.item_name
                      )
                    "
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-autocomplete
                        v-if="editStatus"
                        v-on="on"
                        v-bind="attrs"
                        validate-on-blur
                        background-color="#fff"
                        outlined
                        hide-details
                        dense
                        height="32"
                        item-text="material_name"
                        item-value="_id"
                        @click.native="$event.cancelBubble = true"
                        @change="onItemChange"
                        append-icon="mdi-chevron-down"
                        item-color="#D9D9D9"
                        color="#000"
                        v-model="productData.item"
                        :items="dynamicItemDropdown.goodsList"
                        :menu-props="{ bottom: true, offsetY: true }"
                        return-object
                        :rules="[
                          (v) => !!v && !!v.material_code && !!v.material_name,
                        ]"
                        required
                        class="dropdown-input"
                      >
                        <template v-slot:item="{ item }">
                          <v-list-item-content>
                            <v-list-item-title class="dropdown-input--text">{{
                              item.material_name
                            }}</v-list-item-title>
                          </v-list-item-content>
                        </template>
                        <template v-slot:no-data>
                          <v-list-item>
                            <v-list-item-content>
                              <v-list-item-title
                                class="dropdown-input--no-data"
                              >
                                <v-icon color="#bebebe">
                                  mdi-alert-circle-outline
                                </v-icon>
                                ไม่พบข้อมูล</v-list-item-title
                              >
                            </v-list-item-content>
                          </v-list-item>
                        </template>
                      </v-autocomplete>
                      <v-text-field
                        v-else
                        validate-on-blur
                        hide-details
                        outlined
                        v-on="on"
                        v-bind="attrs"
                        height="32"
                        color="#000"
                        readonly
                        background-color="#fff"
                        :value="productData.item_name"
                        @click.native="$event.cancelBubble = true"
                        class="input-text"
                      ></v-text-field>
                    </template>
                    <span class="font-theme">{{
                      productData.item?.material_name || productData?.item_name
                    }}</span>
                  </v-tooltip>
                </v-col>
              </v-row>
            </v-col>
            <v-col
              cols="12"
              sm="6"
              class="mt-3 mt-sm-0"
            >
              <v-row
                no-gutters
                align="center"
              >
                <v-col
                  cols="12"
                  md="12"
                  lg="5"
                  class="pl-sm-2 pl-md-6"
                >
                  รหัสสินค้า
                </v-col>
                <v-col
                  cols="12"
                  md="12"
                  lg="7"
                  class="pl-sm-2 pl-md-6"
                >
                  <v-tooltip
                    top
                    :disabled="
                      !(productData.item?.material_code || productData?.item_id)
                    "
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        validate-on-blur
                        hide-details
                        outlined
                        v-on="on"
                        v-bind="attrs"
                        height="32"
                        color="#000"
                        readonly
                        :background-color="editStatus ? '#EAEAEA' : '#fff'"
                        :value="
                          productData.item?.material_code ||
                          productData?.item_id
                        "
                        @click.native="$event.cancelBubble = true"
                        class="input-text"
                      ></v-text-field>
                    </template>
                    <span class="font-theme">{{
                      productData.item?.material_code || productData?.item_id
                    }}</span>
                  </v-tooltip>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row
            no-gutters
            align="center"
            class="header-product-section"
          >
            <v-col
              cols="12"
              sm="6"
            >
              <v-row
                no-gutters
                class="pr-sm-2 pr-md-6"
                align="center"
              >
                <v-col
                  cols="12"
                  lg="4"
                >
                  ราคาต่อหน่วย
                </v-col>
                <v-col
                  cols="12"
                  lg="7"
                >
                  <v-tooltip
                    top
                    :disabled="!productData.unit_price"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        validate-on-blur
                        hide-details
                        outlined
                        v-on="on"
                        v-bind="attrs"
                        height="32"
                        color="#000"
                        background-color="#fff"
                        :readonly="!editStatus"
                        v-model="productData.unit_price"
                        @keyup.prevent="delayFuncForTyping(calculateTotalPrice)"
                        @blur="mapDataForSendToParent()"
                        @click.native="$event.cancelBubble = true"
                        v-currency="{
                          distractionFree: false,
                          currency: null,
                          allowNegative: false,
                          precision: 2,
                        }"
                        :rules="[...rules.required, ...rules.currency]"
                        required
                        class="input-text"
                      ></v-text-field>
                    </template>
                    <span>{{ productData.unit_price }}</span>
                  </v-tooltip>
                </v-col>
              </v-row>
            </v-col>
            <v-col
              cols="12"
              sm="6"
              class="mt-3 mt-sm-0"
            >
              <v-row
                no-gutters
                align="center"
              >
                <v-col
                  cols="12"
                  lg="5"
                  class="pl-sm-2 pl-md-6"
                >
                  ยอดรวม
                </v-col>
                <v-col
                  cols="12"
                  lg="7"
                  class="pl-sm-2 pl-md-6"
                >
                  <v-tooltip
                    top
                    :disabled="!productData.total_product_price"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        validate-on-blur
                        hide-details
                        outlined
                        v-on="on"
                        v-bind="attrs"
                        height="32"
                        color="#000"
                        readonly
                        v-model="productData.total_product_price"
                        :background-color="editStatus ? '#EAEAEA' : '#fff'"
                        @click.native="$event.cancelBubble = true"
                        class="input-text"
                      ></v-text-field>
                    </template>
                    <span class="font-theme">{{
                      productData.total_product_price
                    }}</span>
                  </v-tooltip>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-row>
      </v-expansion-panel-header>
      <v-expansion-panel-content class="extension-container">
        <v-row class="extension-row-container">
          <v-row
            no-gutters
            align="center"
          >
            <v-col
              cols="12"
              sm="6"
            >
              <v-row
                no-gutters
                class="pr-sm-2 pr-md-6"
                align="center"
              >
                <v-col
                  cols="12"
                  lg="4"
                >
                  ปริมาณ
                </v-col>
                <v-col
                  cols="12"
                  lg="7"
                >
                  <v-tooltip
                    top
                    :disabled="!productData.amount"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        validate-on-blur
                        hide-details
                        outlined
                        v-on="on"
                        v-bind="attrs"
                        height="32"
                        color="#000"
                        background-color="#fff"
                        :readonly="!editStatus"
                        v-model="productData.amount"
                        class="input-text"
                        @keyup.prevent="delayFuncForTyping(calculateTotalPrice)"
                        @blur="mapDataForSendToParent()"
                        v-currency="{
                          distractionFree: false,
                          currency: null,
                          allowNegative: false,
                          precision: 2,
                        }"
                        :rules="[...rules.required, ...rules.currency]"
                        required
                      ></v-text-field>
                    </template>
                    <span>{{ productData.amount }}</span>
                  </v-tooltip>
                </v-col>
              </v-row>
            </v-col>
            <v-col
              cols="12"
              sm="6"
              class="mt-3 mt-sm-0"
            >
              <v-row
                no-gutters
                align="center"
              >
                <v-col
                  cols="12"
                  lg="5"
                  class="pl-sm-2 pl-md-6"
                >
                  หน่วยนับ
                </v-col>
                <v-col
                  cols="12"
                  lg="7"
                  class="pl-sm-2 pl-md-6"
                >
                  <v-tooltip
                    top
                    :disabled="!productData.unit_type"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-select
                        v-if="editStatus"
                        v-on="on"
                        v-bind="attrs"
                        validate-on-blur
                        outlined
                        hide-details
                        dense
                        height="32"
                        append-icon="mdi-chevron-down"
                        item-color="#D9D9D9"
                        v-model="productData.unit_type"
                        @blur="mapDataForSendToParent()"
                        :items="dynamicItemDropdown.unitList"
                        color="#000"
                        background-color="#fff"
                        :menu-props="{ bottom: true, offsetY: true }"
                        :rules="[...rules.required]"
                        required
                        class="dropdown-input"
                      >
                        <template v-slot:item="data">
                          <v-list-item-content>
                            <v-list-item-title class="dropdown-input--text">{{
                              data.item
                            }}</v-list-item-title>
                          </v-list-item-content>
                        </template>
                      </v-select>
                      <v-text-field
                        v-else
                        validate-on-blur
                        hide-details
                        outlined
                        v-on="on"
                        v-bind="attrs"
                        height="32"
                        color="#000"
                        readonly
                        background-color="#fff"
                        v-model="productData.unit_type"
                        class="input-text"
                      ></v-text-field>
                    </template>
                    <span class="font-theme">{{ productData.unit_type }}</span>
                  </v-tooltip>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row
            no-gutters
            class="pt-3"
            align="center"
          >
            <v-col
              cols="12"
              sm="6"
            >
              <v-row
                no-gutters
                class="pr-sm-2 pr-md-6"
                align="center"
              >
                <v-col
                  cols="12"
                  lg="4"
                >
                  สกุลเงิน
                </v-col>
                <v-col
                  cols="12"
                  :sm="productData.currency === 'บาท' ? '12' : '7'"
                  :lg="productData.currency === 'บาท' ? '7' : '4'"
                  :class="{ 'pr-sm-1 pr-lg-3': productData.currency !== 'บาท' }"
                >
                  <v-tooltip
                    top
                    :disabled="!productData.currency"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-select
                        v-if="editStatus"
                        v-on="on"
                        v-bind="attrs"
                        outlined
                        hide-details
                        dense
                        height="32"
                        append-icon="mdi-chevron-down"
                        item-color="#D9D9D9"
                        :items="selectedBiz.tax_id === '0107544000094'? staticItemDropdown.currencyBizInet : staticItemDropdown.currencyAll"
                        v-model="productData.currency"
                        color="#000"
                        background-color="#fff"
                        :menu-props="{ bottom: true, offsetY: true }"
                        :rules="[...rules.required]"
                        :error="!isSameAllCurrency"
                        @change="mapDataForSendToParent()"
                        required
                        class="dropdown-input"
                      >
                        <template v-slot:item="data">
                          <v-list-item-content>
                            <v-list-item-title class="dropdown-input--text">{{
                              data.item
                            }}</v-list-item-title>
                          </v-list-item-content>
                        </template>
                      </v-select>
                      <v-text-field
                        v-else
                        validate-on-blur
                        hide-details
                        outlined
                        v-on="on"
                        v-bind="attrs"
                        height="32"
                        color="#000"
                        readonly
                        background-color="#fff"
                        v-model="productData.currency"
                        class="input-text"
                      ></v-text-field>
                    </template>
                    <span class="font-theme">{{ productData.currency }}</span>
                  </v-tooltip>
                </v-col>
                <v-col
                  v-if="productData.currency !== 'บาท'"
                  cols="12"
                  sm="5"
                  lg="3"
                  class="pt-3 pt-sm-0"
                >
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        hide-details
                        outlined
                        v-on="on"
                        v-bind="attrs"
                        placeholder="อัตราแลกแปลี่ยน ณ ปัจจุบัน"
                        height="32"
                        color="#000"
                        background-color="#fff"
                        class="input-text"
                        :readonly="!editStatus"
                        v-model="productData.currency_exchange"
                        @keyup.prevent="
                          delayFuncForTyping(mapDataForSendToParent)
                        "
                        v-currency="{
                          distractionFree: false,
                          currency: null,
                          allowNegative: false,
                          precision: 2,
                        }"
                        :rules="[
                          ...rules.required,
                          ...rules.textLengthNotOver50,
                        ]"
                        :error="!isSameAllCurrency"
                        required
                      ></v-text-field>
                    </template>
                    <span class="font-theme"
                      >อัตราแลกแปลี่ยน ณ ปัจจุบัน
                      {{ productData.currency_exchange || null }}</span
                    >
                  </v-tooltip>
                </v-col>
              </v-row>
            </v-col>
            <v-col
              cols="12"
              sm="6"
              class="mt-3 mt-sm-0"
            >
              <v-row
                no-gutters
                align="center"
              >
                <v-col
                  cols="12"
                  lg="5"
                  class="pl-sm-2 pl-md-6"
                >
                  หมวดตัดงบ
                </v-col>
                <v-col
                  cols="12"
                  lg="7"
                  class="pl-sm-2 pl-md-6"
                >
                  <v-tooltip
                    top
                    :disabled="!productData.cut_budget_type"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-select
                        v-if="editStatus"
                        validate-on-blur
                        v-on="on"
                        v-bind="attrs"
                        outlined
                        hide-details
                        dense
                        height="32"
                        append-icon="mdi-chevron-down"
                        item-color="#D9D9D9"
                        v-model="productData.cut_budget_type"
                        @blur="mapDataForSendToParent()"
                        @change="onItemChange"
                        :items="cutBudgetCategories"
                        color="#000"
                        :disabled="productData.disabledSelect"
                        :background-color="productData.disabledSelect ? '#EAEAEA' : '#fff'"
                        :menu-props="{ bottom: true, offsetY: true }"
                        :rules="[...rules.required]"
                        required
                        class="dropdown-input"
                      >
                        <template v-slot:item="data">
                          <v-list-item-content>
                            <v-list-item-title class="dropdown-input--text">{{
                              data.item
                            }}</v-list-item-title>
                          </v-list-item-content>
                        </template>
                      </v-select>
                      <v-text-field
                        v-else
                        validate-on-blur
                        hide-details
                        outlined
                        v-on="on"
                        v-bind="attrs"
                        height="32"
                        color="#000"
                        readonly
                        background-color="#fff"
                        v-model="productData.cut_budget_type"
                        class="input-text"
                      ></v-text-field>
                    </template>
                    <span class="font-theme">{{
                      productData.cut_budget_type
                    }}</span>
                  </v-tooltip>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row
            no-gutters
            class="pt-3"
            align="center"
          >
            <v-col
              cols="12"
              sm="6"
            >
              <v-row
                no-gutters
                class="pr-sm-2 pr-md-6"
                align="center"
              >
                <v-col
                  cols="12"
                  lg="4"
                  align-self="center"
                >
                  Vendor Name
                </v-col>
                <v-col
                  cols="12"
                  lg="7"
                >
                  <v-tooltip
                    top
                    :disabled="
                      !(
                        productData?.vendor?.vendor_name_th ||
                        productData?.vender_name
                      )
                    "
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-autocomplete
                        v-if="editStatus"
                        validate-on-blur
                        v-on="on"
                        v-bind="attrs"
                        outlined
                        hide-details
                        dense
                        height="32"
                        item-text="vendor_name_th"
                        item-value="_id"
                        append-icon="mdi-chevron-down"
                        item-color="#D9D9D9"
                        color="#000"
                        background-color="#fff"
                        v-model="productData.vendor"
                        @change="conjunctProductData()"
                        :items="dynamicItemDropdown.vendorList"
                        :filter="customFilter"
                        :menu-props="{ bottom: true, offsetY: true }"
                        return-object
                        :rules="[
                          (v) => !!v && !!v.vendor_name_th && !!v.vendor_code,
                        ]"
                        required
                        class="dropdown-input"
                      >
                        <template v-slot:item="data">
                          <v-list-item-content>
                            <v-list-item-title class="dropdown-input--text">{{
                              data.item.vendor_name_th
                            }}</v-list-item-title>
                          </v-list-item-content>
                        </template>
                        <template v-slot:no-data>
                          <v-list-item>
                            <v-list-item-content>
                              <v-list-item-title class="dropdown-input--text"
                                >ไม่พบข้อมูล</v-list-item-title
                              >
                            </v-list-item-content>
                          </v-list-item>
                        </template>
                      </v-autocomplete>
                      <v-text-field
                        v-else
                        validate-on-blur
                        hide-details
                        outlined
                        v-on="on"
                        v-bind="attrs"
                        height="32"
                        color="#000"
                        readonly
                        :background-color="
                          editStatus && indexProduct ? '#EAEAEA' : '#fff'
                        "
                        :value="
                          productData?.vendor?.vendor_name_th ||
                          productData?.vender_name
                        "
                        class="input-text"
                      ></v-text-field>
                    </template>
                    <span class="font-theme">{{
                      productData?.vendor?.vendor_name_th ||
                      productData?.vender_name
                    }}</span>
                  </v-tooltip>
                </v-col>
              </v-row>
            </v-col>
            <v-col
              cols="12"
              sm="6"
              class="mt-3 mt-sm-0"
            >
              <v-row
                no-gutters
                align="center"
              >
                <v-col
                  cols="12"
                  lg="5"
                  class="pl-sm-2 pl-md-6"
                >
                  Vendor Code
                </v-col>
                <v-col
                  cols="12"
                  lg="7"
                  class="pl-sm-2 pl-md-6"
                >
                  <v-tooltip
                    top
                    :disabled="
                      !(
                        productData?.vendor?.vendor_code ||
                        productData?.vender_code
                      )
                    "
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        validate-on-blur
                        hide-details
                        outlined
                        v-on="on"
                        v-bind="attrs"
                        height="32"
                        color="#000"
                        readonly
                        :background-color="editStatus ? '#EAEAEA' : '#fff'"
                        :value="
                          productData?.vendor?.vendor_code ||
                          productData?.vender_code
                        "
                        class="input-text"
                      ></v-text-field>
                    </template>
                    <span class="font-theme">{{
                      productData?.vendor?.vendor_code ||
                      productData?.vender_code
                    }}</span>
                  </v-tooltip>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row
            no-gutters
            class="pt-3"
            align="center"
          >
            <v-col
              cols="12"
              sm="6"
              align-self="center"
            >
              <v-row
                no-gutters
                class="pr-sm-2 pr-md-6"
                align="center"
              >
                <v-col
                  cols="12"
                  lg="4"
                >
                  หมวดงบประมาณ
                </v-col>
                <v-col
                  cols="12"
                  lg="7"
                >
                  <v-tooltip
                    top
                    :disabled="!productData.budget_type"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-select
                        v-if="editStatus"
                        validate-on-blur
                        v-on="on"
                        v-bind="attrs"
                        outlined
                        hide-details
                        dense
                        height="32"
                        append-icon="mdi-chevron-down"
                        item-color="#D9D9D9"
                        color="#000"
                        v-model="productData.budget_type"
                        :disabled="productData.disabledSelect"
                        :background-color="productData.disabledSelect ? '#EAEAEA' : '#fff'"
                        :items="staticItemDropdown.budgetCategories"
                        :menu-props="{ bottom: true, offsetY: true }"
                        :rules="[...rules.required]"
                        required
                        class="dropdown-input"
                        @change="conjunctProductData()"
                      >
                        <template v-slot:item="data">
                          <v-list-item-content>
                            <v-list-item-title class="dropdown-input--text">{{
                              data.item
                            }}</v-list-item-title>
                          </v-list-item-content>
                        </template>
                        <template v-slot:no-data>
                          <v-list-item>
                            <v-list-item-content>
                              <v-list-item-title class="dropdown-input--text"
                                >ไม่พบข้อมูล</v-list-item-title
                              >
                            </v-list-item-content>
                          </v-list-item>
                        </template>
                      </v-select>
                      <v-text-field
                        v-else
                        validate-on-blur
                        hide-details
                        outlined
                        v-on="on"
                        v-bind="attrs"
                        height="32"
                        color="#000"
                        readonly
                        :background-color="
                          editStatus && indexProduct ? '#EAEAEA' : '#fff'
                        "
                        v-model="productData.budget_type"
                        class="input-text"
                      ></v-text-field>
                    </template>
                    <span class="font-theme">{{
                      productData.budget_type
                    }}</span>
                  </v-tooltip>
                </v-col>
              </v-row>
            </v-col>
            <v-col
              cols="12"
              sm="6"
              class="mt-3 mt-sm-0"
            >
              <v-row
                no-gutters
                align="center"
              >
                <v-col
                  cols="12"
                  lg="5"
                  class="pl-sm-2 pl-md-6"
                >
                  งบประมาณหมวด
                </v-col>
                <v-col
                  cols="12"
                  lg="7"
                  class="pl-sm-2 pl-md-6"
                >
                  <v-tooltip
                    top
                    :disabled="
                      !(
                        isCopyDocument === true && selectedBiz.tax_id === '0107544000094' ?
                        productData.item?.gl_account : (  productData.item?.gl_account || productData?.type_budget )
                      )
                    "
                  > 
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        ref="glAccountField"
                        validate-on-blur
                        hide-details
                        outlined
                        v-on="on"
                        v-bind="attrs"
                        height="32"
                        color="#000"
                        readonly
                        :background-color="editStatus ? '#EAEAEA' : '#fff'"
                        :value="
                        isCopyDocument === true && selectedBiz.tax_id === '0107544000094' ?
                        productData.item?.gl_account : (  productData.item?.gl_account || productData?.type_budget )
                        "
                        :rules="[...rules.required]"
                        required
                        class="input-text"
                      ></v-text-field>
                    </template>
                    <span class="font-theme">{{
                      productData.item?.gl_account || productData?.type_budget
                    }}</span>
                  </v-tooltip>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row
            no-gutters
            class="pt-3"
            align="center"
          >
            <v-col
              cols="12"
              sm="6"
            >
              <v-row
                no-gutters
                class="pr-sm-2 pr-md-6"
                align="center"
              >
                <v-col
                  cols="12"
                  lg="4"
                >
                  Cost Center
                </v-col>
                <v-col
                  cols="12"
                  lg="7"
                >
                  <v-tooltip
                    top
                    :disabled="
                      !(
                        productData.cost_center?.costcenter_code ||
                        productData?.cost_center_id
                      )
                    "
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-select
                        v-if="editStatus"
                        v-on="on"
                        v-bind="attrs"
                        outlined
                        hide-details
                        dense
                        height="32"
                        item-text="costcenter_code"
                        append-icon="mdi-chevron-down"
                        item-color="#D9D9D9"
                        color="#000"
                        background-color="#fff"
                        v-model="productData.cost_center"
                        :items="dynamicItemDropdown.costCenterList"
                        @change="mapDataForSendToParent()"
                        :menu-props="{ bottom: true, offsetY: true }"
                        return-object
                        :rules="[
                          (v) =>
                            !!v &&
                            !!v.costcenter_code &&
                            !!v.coscenter_description,
                        ]"
                        required
                        class="dropdown-input"
                      >
                        <template v-slot:item="data">
                          <v-list-item-content>
                            <v-list-item-title class="dropdown-input--text">{{
                              data.item.costcenter_code
                            }}</v-list-item-title>
                          </v-list-item-content>
                        </template>
                        <template v-slot:no-data>
                          <v-list-item>
                            <v-list-item-content>
                              <v-list-item-title
                                class="dropdown-input--no-data"
                              >
                                <v-icon color="#bebebe">
                                  mdi-alert-circle-outline
                                </v-icon>
                                ไม่พบข้อมูล</v-list-item-title
                              >
                            </v-list-item-content>
                          </v-list-item>
                        </template>
                      </v-select>
                      <v-text-field
                        v-else
                        validate-on-blur
                        hide-details
                        outlined
                        v-on="on"
                        v-bind="attrs"
                        height="32"
                        color="#000"
                        readonly
                        background-color="#fff"
                        v-model="productData.cost_center_id"
                        class="input-text"
                      ></v-text-field>
                    </template>
                    <span class="font-theme">{{
                      productData.cost_center?.costcenter_code ||
                      productData?.cost_center_id
                    }}</span>
                  </v-tooltip>
                </v-col>
              </v-row>
            </v-col>
            <v-col
              cols="12"
              sm="6"
              class="mt-3 mt-sm-0"
            >
              <v-row
                no-gutters
                align="center"
              >
                <v-col
                  cols="12"
                  lg="5"
                  class="pl-sm-2 pl-md-6"
                >
                  Cost Center Description
                </v-col>
                <v-col
                  cols="12"
                  lg="7"
                  class="pl-sm-2 pl-md-6"
                >
                  <v-tooltip
                    top
                    :disabled="
                      !(
                        productData.cost_center?.coscenter_description ||
                        productData?.cost_center_description
                      )
                    "
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        validate-on-blur
                        hide-details
                        outlined
                        v-on="on"
                        v-bind="attrs"
                        height="32"
                        color="#000"
                        readonly
                        :background-color="editStatus ? '#EAEAEA' : '#fff'"
                        :value="
                          productData.cost_center?.coscenter_description ||
                          productData?.cost_center_description
                        "
                        class="input-text"
                      ></v-text-field>
                    </template>
                    <span class="font-theme">{{
                      productData.cost_center?.coscenter_description ||
                      productData?.cost_center_description
                    }}</span>
                  </v-tooltip>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row
            no-gutters
            class="pt-0 pt-sm-3"
            align="center"
          >
            <v-col
              cols="12"
              sm="6"
              class="mt-3 mt-sm-0 order-2 order-sm-1"
            >
              <v-row
                no-gutters
                align="center"
                class="pr-sm-2 pr-md-6"
              >
                <v-col
                  cols="12"
                  lg="4"
                  align-self="start"
                >
                  รายละเอียดสินค้า
                </v-col>
                <v-col
                  cols="12"
                  lg="7"
                >
                  <v-textarea
                    validate-on-blur
                    outlined
                    rows="5"
                    :readonly="!editStatus"
                    color="#000"
                    background-color="#fff"
                    v-model="productData.product_detail"
                    @keypress="filterInput"
                    :rules="[...rules.textLengthNotOver50, ...rules.characters]"
                    required
                    @blur="mapDataForSendToParent()"
                    class="input-text text-area-description"
                  ></v-textarea>
                </v-col>
              </v-row>
            </v-col>
            <v-col
              cols="12"
              sm="6"
              align-self="start"
              class="mt-3 mt-sm-0 order-1 order-sm-2"
            >
              <v-row
                v-if="confirmSelectedBiz.tax_id === '0107544000094'"
                no-gutters
                class="mt-3 pb-3"
                align="center"
              >
                <v-col
                  cols="12"
                  lg="5"
                  class="pl-sm-2 pl-md-6"
                >
                  Pur Group Name
                </v-col>
                <v-col
                  cols="12"
                  lg="7"
                  class="pl-sm-2 pl-md-6"
                >
                  <v-tooltip
                    top
                    :disabled="!productData.pur_group_name"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-select
                        v-if="editStatus"
                        v-on="on"
                        v-bind="attrs"
                        validate-on-blur
                        outlined
                        hide-details
                        dense
                        height="32"
                        append-icon="mdi-chevron-down"
                        item-color="#D9D9D9"
                        :items="staticItemDropdown.purGroupName"
                        v-model="productData.pur_group_name"
                        :disabled="productData.disabledSelect"
                        :background-color="productData.disabledSelect ? '#EAEAEA' : '#fff'"
                        color="#000"
                        :menu-props="{ bottom: true, offsetY: true }"
                        :rules="[...rules.required]"
                        required
                        @blur="mapDataForSendToParent()"
                        class="dropdown-input"
                      >
                        <template v-slot:item="data">
                          <v-list-item-content>
                            <v-list-item-title class="dropdown-input--text">{{
                              data.item
                            }}</v-list-item-title>
                          </v-list-item-content>
                        </template>
                      </v-select>
                      <v-text-field
                        v-else
                        validate-on-blur
                        hide-details
                        outlined
                        v-on="on"
                        v-bind="attrs"
                        height="32"
                        color="#000"
                        readonly
                        background-color="#fff"
                        v-model="productData.pur_group_name"
                        class="input-text"
                      ></v-text-field>
                    </template>
                    <span class="font-theme">{{
                      productData.pur_group_name
                    }}</span>
                  </v-tooltip>
                </v-col>
              </v-row>
              <v-row
                no-gutters
                align="center"
              >
                <v-col
                  cols="12"
                  lg="5"
                  class="pl-sm-2 pl-md-6"
                >
                  ส่วนลด
                </v-col>
                <v-col
                  cols="12"
                  lg="7"
                  class="pl-sm-2 pl-md-6"
                >
                  <v-tooltip
                    top
                    :disabled="!productData.discount"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        validate-on-blur
                        hide-details
                        outlined
                        v-on="on"
                        v-bind="attrs"
                        height="32"
                        :readonly="!editStatus"
                        color="#000"
                        background-color="#fff"
                        @keyup.prevent="
                          delayFuncForTyping(mapDataForSendToParent)
                        "
                        v-model="productData.discount"
                        class="input-text"
                        v-currency="{
                          distractionFree: false,
                          currency: null,
                          allowNegative: false,
                          precision: 2,
                        }"
                        :rules="[...rules.required]"
                        required
                      ></v-text-field>
                    </template>
                    <span class="font-theme">{{ productData.discount }}</span>
                  </v-tooltip>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-row>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
import { mapGetters } from "vuex";
import _ from "lodash";
import { MainFunction } from "@/functions/mainFunction.js";

export default {
  props: {
    isCopyDocument: {
      type: Boolean,
      default: false
    },
    indexProduct: {
      required: true,
      type: Number,
    },
    editStatus: {
      required: true,
      type: Boolean,
    },
    isProductOnlyOne: {
      required: true,
      type: Boolean,
    },
    deleteProduct: {
      require: true,
      type: Function,
    },
    isSameAllCurrency: {
      require: true,
      type: Boolean,
    },
    dynamicItemDropdown: {
      required: true,
      type: Object,
      default: () => ({
        documentType: [],
        goodsList: [],
        vendorList: [],
        costCenterList: [],
        unitList: [],
      }),
    },
    productDetail: {
      required: true,
      type: Object,
    },
  },
  data: () => ({
    staticItemDropdown: {
      currencyAll: [
        "ดอลลาร์ออสเตรเลีย",
        "ยูโร European euro",
        "ดอลลาร์สิงคโปร์",
        "ดอลลาร์สหรัฐ",
        "บาท",
      ],
       currencyBizInet: [
        "ดอลลาร์ออสเตรเลีย",
        "ยูโร European euro",
        "ดอลลาร์สิงคโปร์",
        "ดอลลาร์สหรัฐ",
        "หยวน",
        "บาท",
      ],
      cutBudgetCategories: [],
      budgetCategories: ["งบลงทุน", "งบรายจ่ายประจำ", "งบดำเนินงาน"],
      unitCategories: ["Unit", "Month", "Project"],
      purGroupName: ["BD Support", "Job Support", "GA Support"],
    },
    productData: {},
    rules: {
      required: [(v) => !!v],
      textLengthNotOver50: [
        (v) =>
          (v && v.length <= 500) || "เกินจำนวนตัวอักษรที่กำหนด (500 ตัวอักษร)",
      ],
      currency: [(v) => parseFloat(v) > 0],
      characters: [
        v => !!v && v.trim() !== '', // ตรวจสอบว่ามีค่า
        v => /^[^*;&%$@!^<>+="|?#'"']*$/.test(v) || 'ตรวจพบอักขระต้องห้าม *;&%$\'@!^<>+=|?#\"' // ตรวจสอบสัญลักษณ์ต้องห้าม
      ],
    },
    typingCurrencyTimeout: null,
  }),
  watch: {
    productDetail: {
      handler(val) {
        if (!val) return;
            this.$set(this.productData, 'vendor', _.cloneDeep(val.vendor));
            this.$set(this.productData, 'budget_type', val.budget_type);
            this.$set(this.productData,'item', _.cloneDeep(val.item || {})
        );
      },
      deep: true,
      immediate: true,
    },
    'productData.item.gl_account'(val) {
        if (val) {
          this.$nextTick(() => {
            this.$refs.glAccountField?.resetValidation();
          });
        }
      },
      'productData.type_budget'(val) {
        if (val) {
          this.$nextTick(() => {
            this.$refs.glAccountField?.resetValidation();
          });
        }
    },
  },
  computed: {
    ...mapGetters(["confirmSelectedBiz"]),
    setGetBudgetType () {
        return this.$store.state.budgetType
    },
    selectedBiz() {
        return this.$store.state.confirmSelectedBiz
    },
  },
  
mounted() {
  this.cutBudgetCategories = this.setGetBudgetType?.map(e => e.type_name)
  this.productData = _.cloneDeep(this.productDetail) || {}
   if (!this.productData.item) {
    this.$set(this.productData, 'item', {});
  } else {
    this.$set(this.productData, 'item', _.cloneDeep(this.productData.item));
  }
  if (this.isCopyDocument) {
    this.onChangeCostCenter()
  }
  if (this.selectedBiz.tax_id === '0107544000094' && this.productData.requirement === 'เร่งด่วนพิเศษ') {
      this.productData.disabledSelect = true
  } 
 },
  methods: {
    onItemChange() {
      this.$nextTick(() => {
        this.mapDataForSendToParent();
        this.emitMaterialId();
      });
    },
    mapDataForSendToParent() {
      this.$emit("send-product-price", {
        index: this.indexProduct,
        product: this.productData,
      });
       this.AllCodes() 
    },
    emitMaterialId() {
      this.$emit('sendMaterialId', {
        index: this.indexProduct,
        material_code: this.productData.item?.material_code || '',
        cut_budget_type : this.productData.cut_budget_type || ''
      });
    },
    removeProduct(index) {
      this.deleteProduct(index);
    },
    setDefaultData(type) {
      const data = { ...this.productData }
      if (type === 'เร่งด่วนพิเศษ') {
        data.cut_budget_type = 'ต้นทุนขาย (COGS)'
        data.budget_type = 'งบดำเนินงาน'
        data.pur_group_name = 'Job Support'
        data.disabledSelect = true
      } else {
        data.disabledSelect = false
        // data.cut_budget_type = ''
        // data.budget_type = ''
        // data.pur_group_name = ''
      }
      this.productData = { ...data }
      return { ...data }
    },
    calculateTotalPrice() {
      let { unit_price, amount } = this.productData;
      unit_price = this.replaceCommaToNumber(unit_price);
      amount = this.replaceCommaToNumber(amount);

      const total_product_price = (unit_price * amount).toFixed(2);
      this.$set(
        this.productData,
        "total_product_price",
        this.addComma(total_product_price)
      );

      if (total_product_price > 0) {
        this.mapDataForSendToParent();
      }
    },
     AllCodes() {
       if (this.selectedBiz.tax_id === '0107544000094') {
          const newItem = _.cloneDeep(this.productData.item)
          newItem.gl_account = ''
          this.$set(this.productData, 'item', newItem)
      }
      if (
        this.productData?.item?.material_code &&
        this.productData?.vendor?.vendor_code &&
        this.productData?.cost_center?.costcenter_code &&
        this.selectedBiz.tax_id === '0107544000094'
      ) {
        this.onChangeCostCenter();
      }
    },
    onChangeCostCenter() {
        this.$emit('request-gl-account', {
          index: this.indexProduct,
          product: _.cloneDeep(this.productData),
        });
    },
    delayFuncForTyping(callFunc) {
      clearTimeout(this.typingCurrencyTimeout);
      this.typingCurrencyTimeout = setTimeout(() => {
        callFunc();
      }, 500);
    },
    replaceCommaToNumber(value) {
      return Number(value?.replace(/,/g, "") || "0");
    },
    addComma(value) {
      return MainFunction.addComma(Number(value || "0"));
    },
    conjunctProductData() {
      const { vendor, budget_type } = this.productData;
      if (this.indexProduct === 0) {
        this.$emit("conjunct-product", {
          vendor,
          budget_type,
        });
      }
      this.AllCodes() 
    },
    sendProductData() {
      return { ...this.productData };
    },
    filterInput(event) {
      const char = String.fromCharCode(event.keyCode);
      const validChars = /[^*;&%$@!^<>+="|?#']/;
        if (!validChars.test(char)) {
              event.preventDefault();
        }
    },
    customFilter (item, queryText) {
      if (!queryText) return true
      const search = queryText.toLowerCase()
      return (
        (item.vendor_code && item.vendor_code.toLowerCase().includes(search)) ||
        (item.vendor_name_th && item.vendor_name_th.toLowerCase().includes(search)) ||
        (item.keyword && item.keyword.toLowerCase().includes(search))
      )
    }
  },
};
</script>

<style scoped>
.main-container {
  /* padding-bottom: 20px; */
  color: #000000;
  font-family: "Noto Sans Thai", sans-serif !important;
}

.main-container >>> .v-expansion-panel {
  box-shadow: none;
}

.main-container >>> .v-expansion-panel > .v-expansion-panel-header {
  padding: 0;
  font-size: 16px;
  line-height: 1.5;
}

.order-product-container {
  display: flex;
  justify-content: space-between;
  padding: 10px 2% 0% 2%;
}

.header-product-section {
  padding: 0% 5.7% 0% 5.7%;
  padding-top: 12px;
}

.row {
  width: 100%;
  margin: 0% !important;
}

.number-product {
  width: 35px;
  height: 35px;
  background: transparent !important;
  font-size: 16px;
  border-radius: 4px;
  border: 1px solid #000000;
  font-weight: 700 !important;

  display: flex;
  justify-content: center;
  align-items: center;
}

.position-delete-product {
  min-width: 0 !important;
}

.dropdown-input >>> .v-input__control > .v-input__slot {
  padding-right: 0px !important;
  min-height: auto !important;
}

.dropdown-input
  >>> .v-input__control
  > .v-input__slot
  > .v-select__slot
  > .v-input__append-inner {
  display: flex;
  height: 100%;
  align-items: center;
}

.dropdown-input
  >>> .v-input__control
  > .v-input__slot
  > .v-select__slot
  > input {
  font-size: 12px;
  line-height: 23px;
}

>>> .v-list-item {
  min-height: auto !important;
  height: 36px !important;
}

.dropdown-input--text {
  line-height: 30px !important;
  font-size: 12px !important;
  font-family: "Noto Sans Thai", sans-serif !important;
}

.dropdown-input--no-data {
  color: #bebebe;
  font-size: 14px !important;
  line-height: 20px !important;
  font-family: "Noto Sans Thai", sans-serif !important;
}

.dropdown-input::v-deep input,
.dropdown-input::v-deep .v-select__selection {
  color: #000 !important;
  -webkit-text-fill-color: #000 !important;
  opacity: 1 !important;
}

.dropdown-input::v-deep .v-input--is-disabled .v-icon {
  color: #000 !important;
  opacity: 1 !important;
}

.input-text {
  border-radius: 5px;
  font-size: 16px;
}

.input-text >>> .v-input__control > .v-input__slot {
  min-height: auto !important;
}

.input-text
  >>> .v-input__control
  > .v-input__slot
  > .v-text-field__slot
  > input {
  line-height: 24px;
  font-size: 12px;
}

.extension-container >>> .v-expansion-panel-content__wrap {
  padding: 0 !important;
}

.extension-row-container {
  padding: 0% 5.7% 20px 5.7%;
}

.text-area-description {
  margin: 0 !important;
}

.text-area-description >>> .v-input__control > .v-input__slot {
  margin-bottom: 4px;
}

.text-area-description >>> .v-input__control > .v-text-field__details {
  margin-bottom: 0px;
}

.text-area-description
  >>> .v-input__control
  > .v-input__slot
  > .v-text-field__slot
  > textarea {
  line-height: 18px !important;
  padding: 8px 8px 8px 0;
}

@media only screen and (max-width: 959px) {
  .number-product {
    left: 30px !important;
    top: -11px !important;
  }

  .position-delete-product {
    right: 30px !important;
    top: -11px !important;
  }
}
</style>
